<template>
<div v-if="field">
<span :class="icon"></span>
<span v-if="field.minValue && field.maxValue">
  {{ label }}: {{ field.minValue }} – {{ field.maxValue }}
</span>
<span v-else-if="field.minValue">
  {{ label }}: {{ $t("fieldMin") }} {{ field.minValue }}
</span>
<span v-else-if="field.maxValue">
  {{ label }}: {{ $t("fieldMax") }} {{ field.maxValue }}
</span>
</div>
<div v-else>
  <br>
</div>
</template>

<script>
export default {
  name: "RangeField",

  props: [
    "label",
    "icon",
    "field"
  ]
}
</script>
